import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Carousel from 'sushiweb/Carousel';
import parse from 'html-react-parser';

export const BlockingPopup = ({ content = null, onSubmit = () => {} }) => {
  const { text_data } = content;
  const [imageData, setImageData] = useState(null);
  const [footerMediaData, setFooterMediaData] = useState(null);

  useEffect(() => {
    getImagesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getFooterMediaData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getImagesData = () => {
    const images = content?.images?.map((item) => {
      let image = {};
      image['url'] = item;
      return image;
    });
    setImageData(images);
  };

  const getFooterMediaData = () => {
    const footerMedia = content?.footer_media?.map((item) => {
      let media = {};
      media['url'] = item;
      return media;
    });
    setFooterMediaData(footerMedia);
  };

  const getTexts = () => {
    return text_data?.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <BlockingPopup.Text
            style={{
              color: item.color,
              fontSize: item.size,
              fontWeight: item.weight,
              textAlign: item.align || 'center',
              whiteSpace: 'pre-wrap',
            }}
          >
            {parse(item.text)}
          </BlockingPopup.Text>
          <br></br>
        </React.Fragment>
      );
    });
  };

  return (
    <BlockingPopup.Wrapper>
      {imageData?.length && (
        <BlockingPopup.CarouselWrapper>
          <Carousel
            componentData={imageData}
            componentToRender={CarouselView}
            defaultTheme={false}
            dots={false}
            infinite={false}
            carouselWidth='10rem'
          />
        </BlockingPopup.CarouselWrapper>
      )}
      <BlockingPopup.TextWrapper>{getTexts()}</BlockingPopup.TextWrapper>

      {footerMediaData?.length ? (
        <BlockingPopup.CarouselWrapper>
          <Carousel
            componentData={footerMediaData}
            componentToRender={CarouselView}
            defaultTheme={false}
            dots={false}
            infinite={false}
            carouselWidth='30rem'
            height='20rem'
          />
        </BlockingPopup.CarouselWrapper>
      ) : (
        ''
      )}

      {content.submit_btn && (
        <BlockingPopup.Button onClick={onSubmit}>
          {content.submit_btn.text}
        </BlockingPopup.Button>
      )}
    </BlockingPopup.Wrapper>
  );
};

const CarouselView = (image) => {
  return (
    <CarouselView.Image
      className='defaultImg'
      src={image.url}
      alt=''
    ></CarouselView.Image>
  );
};

CarouselView.Image = styled.img``;

BlockingPopup.Wrapper = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 2rem 0;
  max-width: 55rem;
  min-width: 50rem;
`;

BlockingPopup.CarouselWrapper = styled.div`
  margin-bottom: 2rem;
`;

BlockingPopup.Button = styled.div`
  background-color: #50b547;
  margin-top: 2rem;
  color: #fff;
  padding: 1rem 4rem;
  text-align: center;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
`;

BlockingPopup.TextWrapper = styled.div`
  text-align: center;
`;

BlockingPopup.Text = styled.div`
  text-align: center;
`;
